import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { HELP_PARTNERS } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import Partner from "./Partner";
import PartnerList from "./PartnerList";

export default function Partners() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_PARTNERS));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate("/backstage/partners/new"));

  return <MasterDetail identifier="id" master={<PartnerList />} detail={<Partner />} />;
}
